import { render } from "./AppWidgetPart.vue?vue&type=template&id=1b5a1cec&scoped=true"
import script from "./AppWidgetPart.vue?vue&type=script&lang=js"
export * from "./AppWidgetPart.vue?vue&type=script&lang=js"

import "./AppWidgetPart.vue?vue&type=style&index=0&id=1b5a1cec&scoped=true&lang=css"

import exportComponent from "/home/sergey/projects/tm/calc_furnace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5a1cec"]])

export default __exports__